import React, { Suspense, useState, useEffect } from "react";
import Pagination from "components/Common/newPagination";
import systemListingService from "./SystemListingServices";
import { AccountsSubProvidersFormState, } from "../../AssetLinking/MenuDrawer";


export default function SubProvider(param: any) {


  const [showBulkDrawer, setShowBulkDrawer] = useState(false);
  const [showAddDrawer, setShowAddDrawer] = useState(false);
  const [drawerMode, setDrawerMode] = useState<"add" | "edit">("add");
  const [editingKey, setEditingKey] = useState<string | null>(null);

  const [editingOn, setEditingOn] = useState<boolean>(false);

  const [confirmationFilter, setConfirmationFilter] = useState<
    "confirmed" | "notConfirmed"
  >("confirmed");



  let [accountSubproviderList, SetaccountSubproviderListing] = useState<any>([]);
  let [accountSubproviderCount, SetaccountSubproviderCount] = useState(0);
  useEffect(() => {

    if (param.activeTab === "Accounts/Sub Provider") {
      accountSubproviderSelect()
    }
  }, [param])




  const openAddDrawer = () => {
    if (!editingOn) return;
    setDrawerMode("add");
    setEditingKey(null);
    setShowAddDrawer(true);
  };

  var payLoad = {
    pageNumber: 1,
    pageSize: 10
  }

  const onPageChange = (e: any) => {
    console.log(e)
    payLoad.pageNumber = e.pageNumber;
    payLoad.pageSize = e.pageSize;
    accountSubproviderSelect();
  };
  const accountSubproviderSelect = () => {

    systemListingService.accountSubproviderList(payLoad).then((res:any) => {

      accountSubproviderList = res;
      SetaccountSubproviderListing(accountSubproviderList)

      accountSubproviderCount = res[0] && res[0].totalRows ? res[0].totalRows : 0;
      SetaccountSubproviderCount(accountSubproviderCount)
    })

  }


  return (
    <div>
      <div className="content-card ws-12">

        <div className="card-header-row ws-12">
          <div className="card-title">Accounts/Sub Providers</div>
          <div className="card-header-actions">
            <span className="pt mt">
              {accountSubproviderCount ? accountSubproviderCount : 0} record(s) found
            </span>
            <button className="icon-btn info" type="button" onClick={() => setEditingOn((prev) => !prev)}  >
              {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}
            </button>
          </div>
        </div>


        <div className="filter-row ws-12" style={{ padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", marginBottom: 12, }}  >
          <div className="filter-input-row" style={{ alignItems: "flex-end" }} >
            {/* Left: Filter + Search */}
            <div className="filter-inline">
              <div className="filter-label">Filter</div>
              <div className="filter-input-group">
                <input
                  className="form-input"
                  placeholder="Search"
                />
                <button className="icon-btn primary" type="button" onClick={accountSubproviderSelect}>
                  Search
                </button>
              </div>
            </div>

            {/* Right: Radio buttons + Bulk Update, aligned to the right */}
            <div className="filter-inline" style={{ alignItems: "flex-end", marginLeft: "auto", gap: 16, display: "flex", }} >
              <div className="confirm-radio-group">
                <label>
                  <input type="radio" name="confirmed" value="confirmed" checked={confirmationFilter === "confirmed"} onChange={() => setConfirmationFilter("confirmed")} />
                  <span>User Confirmed</span>
                </label>
                <label>
                  <input type="radio" name="confirmed" value="notConfirmed" checked={confirmationFilter === "notConfirmed"} onChange={() => setConfirmationFilter("notConfirmed")} />
                  <span>User Not Confirmed</span>
                </label>
              </div>

              <button className="bulk-btn" type="button" onClick={() => setShowBulkDrawer(true)}   >
                Bulk Update
              </button>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="ws-12">

          {accountSubproviderCount > 0 && <div className="allowHscroll">
            <table className={editingOn ? "editing-on newTable" : " newTable"} >
              <thead>
                <tr>
                  <th className="forceSingleLine">Reported AccountCode </th>
                  <th className="forceSingleLine">Reported SubProvider </th>
                  <th className="forceSingleLine">Display AccountCode  </th>
                  <th className="forceSingleLine">Display SubProvider  </th>
                  <th className="forceSingleLine">Display Single AccSub </th>
                  <th className="forceSingleLine">User Confirmation</th>
                  <th > Operations</th>
                </tr>
              </thead>
              <tbody>
                {accountSubproviderList.map((row: any, index: any) => {

                  return (
                    <tr key={index}>
                      <td>{row.fsaAccountCode}</td>
                      <td>{row.fsapSubProvder}</td>
                      <td>{row.showAccountCode}</td>
                      <td> {row.showSingleAccSub}</td>
                      <td>{row.showSingleAccSub}</td>
                      <td>
                        <div className="points-profits">
                          <div className={"pp-switch" + (row?.userConfirmed === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                            <div className="pp-knob" />
                          </div>
                        </div>

                      </td>

                      <td  >
                        <div style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed",   width: '90px', whiteSpace: 'nowrap' }}>
                          <button className="icon-btn edit" title="Edit" type="button" disabled={!editingOn} >
                            <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" >
                              <path d="M12 20h9" />
                              <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
                            </svg>
                          </button>

                          <button className="icon-btn delete" title="Delete" type="button" disabled={!editingOn} onClick={() => { if (!editingOn) return; console.log("Delete row", row); }} >
                            <i className="icon-trash"> </i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <Pagination totalRow={accountSubproviderCount} onPageChange={onPageChange} />
          </div>}

          {accountSubproviderCount === 0 && <div className="ws-12">
            <div className="alert alert-info ws-12 box" >No records to display</div>
          </div>}

        </div>

        <div className="add-row-wrapper"
          style={{ marginTop: 12, display: "flex", justifyContent: "flex-start", }}   >
          <button className="btn-add-row" type="button" disabled={!editingOn} onClick={openAddDrawer}>
            + Add Accounts/Sub Provider
          </button>
        </div>
      </div>



      {/* 
      <AccountsSubProvidersBulkDrawer
        open={showBulkDrawer}
        selected={selected ? {
          reportedAccountCode: selected.reportedAccountCode,
          reportedSubProvider: selected.reportedSubProvider,
          displayAccountCode: selected.displayAccountCode,
          displaySubProvider: selected.displaySubProvider,
        } : null}
        similarCount={0}
        form={{
          bulkFilter,
          bulkSimilarMode,
        }}
        onClose={() => setShowBulkDrawer(false)}
        onReset={handleBulkReset}
        onUpdate={() => setShowBulkDrawer(false)}
        onSearch={() =>
          console.log("Bulk search", { filter: bulkFilter, mode: bulkSimilarMode })
        }
        onFieldChange={(field, value) => {
          if (field === "bulkFilter") setBulkFilter(value as string);
          if (field === "bulkSimilarMode") setBulkSimilarMode(value as BulkSimilarMode);
        }}
      />

      <AccountsSubProvidersDrawer
        open={showAddDrawer}
        mode={drawerMode}
        form={addForm}
        onClose={() => setShowAddDrawer(false)}
        onReset={resetAddForm}
        onSave={handleSaveAdd}
        onFieldChange={(field, value) => handleAddChange(field, value)}
      />
 */}
    </div>
  );
};